function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 1504",
    cx: 17,
    cy: 17,
    r: 17,
    style: {
      fill: "#f5f6f7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 24897",
    d: "M7.6 25.184a1.639 1.639 0 0 1-1.6-1.6V7.6A1.639 1.639 0 0 1 7.6 6h7.753v1.6H7.6v15.985h7.753v1.6zm12.949-4.929L19.4 19.109l2.718-2.718h-9.324v-1.6h9.272l-2.718-2.718 1.146-1.146 4.689 4.689z",
    transform: "translate(2 1)",
    style: {
      fill: "#032541"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.c23b7bf68f231cc7063b6e966d890062.svg";
export { ForwardRef as ReactComponent };